import { Skeleton } from '@/components/ui/skeleton.tsx'

export const TrackingLinksInspectViewSkeleton = () => {
  return (
    <>
      <Skeleton className="mt-8 h-80 bg-skeleton" />
      <Skeleton className="mt-8 h-40 bg-skeleton" />
      <Skeleton className="mt-8 h-96 bg-skeleton" />
    </>
  )
}
